import styled from "styled-components";
import { fonts } from "assets/fontStyles";
import colours from "assets/colours";
import queries, { devices, maxQuery } from "utils/responsivenessHelper";

const Row = styled.div`
  display: flex;
  flex-direction: row;
`;

const Col = styled.div`
  display: flex;
  flex-direction: column;
`;

const BannerContent = styled(Row)`
  ${queries.both(
    {
      flexDirection: "column",
    },
    devices.mobile
  )}
`;

//#region Left

const TitleCol = styled(Col)`
  width: 40%;
  ${queries.both(
    {
      alignItems: "center",
      width: "unset",
    },
    devices.mobile
  )}
`;

const BannerTitle = styled.div`
  ${fonts.heading2};
  margin-bottom: 0.55em;
  max-width: 11em;
  position: relative;
  z-index: 10;
  white-space: unset;
  color: ${colours.white};
  span {
    color: ${colours.zltoLightBlue};
  }

  ${queries.both(
    {
      whiteSpace: "unset",
      maxWidth: "12em",
      textAlign: "center",
    },
    devices.mobile
  )}

  ${maxQuery.both(
    {
      fontSize: "2rem",
    },
    "1550px"
  )}
`;

const BannerSubtitle = styled.div`
  font-style: normal;
  font-weight: bold;
  font-size: 1.125rem;
  line-height: 166%;
  color: ${colours.white};
  margin-bottom: 10px;
`;

const BannerParagraph = styled.div`
  ${fonts.p};
  max-width: 20.5em;
  font-weight: 600;
  color: ${colours.white};

  ${queries.both(
    {
      textAlign: "center",
    },
    devices.mobile
  )}
`;

//#endregion

const InnerRow = styled(Row)`
  flex: 1;
  width: 100%;
  ${queries.both(
    {
      flexDirection: "column-reverse",
      marginTop: 20,
    },
    devices.mobile
  )}
`;

//#region Right
const RightCol = styled(Col)`
  flex: 1;
  position: relative;
  z-index: 10;
  width: 40%;
  z-index: 10;
  justify-content: space-between;

  ${queries.both(
    {
      justifyContent: "center",
      width: "unset",
    },
    devices.mobile
  )}
`;

const ButtonWrapper = styled.div`
  align-self: flex-start;
  position: relative;
  z-index: 10;
  top: 0;
  left: -20px;

  button {
    min-width: 14.5em;
    padding: 0 1em;
  }

  ${queries.both(
    {
      alignSelf: "center",
      left: 0,
    },
    devices.mobile
  )}
`;

const HostedByRow = styled(Row)`
  align-self: flex-end;

  ${queries.both(
    {
      alignSelf: "center",
      marginTop: 20,
      marginBottom: 20,
    },
    devices.mobile
  )}
`;

const Logo = styled.img`
  margin-left: 0.5em;
`;
//#endregion Right

//#region  Graphic

const GraphicContainer = styled.div`
  height: 100%;
  font-size: 1rem;
  margin-left: 35px;
  min-width: 350px;

  ${queries.both(
    {
      display: "none",
    },
    devices.mobile
  )}
`;

const Graphic = styled(Col)`
  background-image: url(${require("assets/images/tasks-banner-graphic.svg")});
  height: 100%;
  position: absolute;
  top: 15;
  background-size: cover;
  background-position: center;
  max-width: 24.125em;
  min-width: 420px;

  ${queries.both(
    {
      display: "none",
    },
    devices.mobile
  )}
`;

const GraphicMobile = styled.img`
  margin-bottom: -38px;
  width: 100%;
  display: none;
  margin-top: -1px;
  ${queries.portrait(
    {
      display: "block",
    },
    devices.phone
  )}
`;

//#endregion

export {
  Row,
  Col,
  RightCol,
  BannerContent,
  BannerTitle,
  BannerSubtitle,
  BannerParagraph,
  Graphic,
  GraphicContainer,
  GraphicMobile,
  InnerRow,
  HostedByRow,
  Logo,
  TitleCol,
  ButtonWrapper,
};
